<template>
  <div class="card editchannel">
    <div class="header">
      <h4 class="title">
        {{ upd_channel.id? translate('notification.to_edit') : translate('notification.to_add') }}
      </h4>
    </div>
    <div class="content">
      <form autocomplete="off">
        <div class="form-item">
          <fg-input
            v-model="upd_channel.name"
            type="text"
            :label="translate('notification.ch_name')"
            :placeholder="translate('notification.ch_name')"
          />
        </div>
        <div class="form-item">
          <label> {{ translate('notification.ch_type') }} </label>
          <sis-select
            v-model="upd_channel.type"
            :options="[{'label':'Telegram', 'id':'telegram'}, {'label':'Email', 'id':'email'}]"
            :searchable="false"
            :clearable="false"
            :show-labels="false"
            :close_on_select="true"
            :clear-on-select="false"
            :hide_selected="true"
          />
        </div>
        <div class="form-item" >
          <div class="form-group telegram" v-if="upd_channel.type == 'telegram'">
            <label>{{translate('notification.ch_params_telegramm')}}
              <span class="mdi mdi-help" @click="text_assistant = !text_assistant"></span>
              <span class="hide_text" :class="{active: text_assistant}">
                {{translate('notification.text_assistant')}}
                <br>
                <a href='https://t.me/sistematicsbot' target="_blank">@sistematicsbot</a>
              </span>

            </label>
            <input
              v-model="upd_channel.chat_id"
              class="form-control border-input error"
              type="text"
              onkeypress="return (event.charCode >= 48 && event.charCode <= 57)"
              :placeholder="translate('notification.ch_params_telegramm')"
            >
          </div>
          <fg-input
            v-if="upd_channel.type == 'email'"
            v-model="upd_channel.email"
            type="text"
            :label="translate('notification.ch_params_email')"
            :placeholder="translate('notification.ch_params_email')"
          />
        </div>

        <div class="text-center">
          <button
            type="submit"
            class="btn btn-success btn-fill btn-wd"
            @click.prevent="updateChannel"
          >
            {{ upd_channel.id? translate('notification.btn.edit') : translate("notification.btn.add") }}
          </button>

          <button
            type="submit"
            class="btn btn-info btn-fill btn-wd"
            @click.prevent="cancel"
          >
            {{ translate('notification.btn.cancel') }}
          </button>

          <button v-if="upd_channel.id !== undefined"
            type="submit"
            class="btn btn-danger btn-fill btn-wd"
            @click.prevent="deleteChannel"
          >
            {{ translate('notification.btn.delete') }}
          </button>
        </div>
        <div class="clearfix" />
      </form>
    </div>
  </div>
</template>
<script>
export default {
  name: "EditChannelForm",
  props: ['channel'],
  data () {
    return {
      upd_channel: {
        name: "",
        chat_id: "",
        email: "",
        params: "",
        type: "telegram"
      },
      text_assistant: false
    }
  },
  beforeMount() {
    if (this.channel.isTrusted == true) {
      this.upd_channel.type = 'telegram'
    }else{
      this.upd_channel = {...this.channel}
      if (this.upd_channel.type == 'telegram') {
        this.upd_channel.chat_id = this.upd_channel.params
      }else if (this.upd_channel.type == 'email') {
        this.upd_channel.email = this.upd_channel.params
      }
      this.upd_channel.params = ''
    }
  },
  methods: {
    clear_params(){
      this.upd_channel.params = ''
    },
    cancel () {
      this.$emit('close')
    },
    updateChannel () {
      if (this.upd_channel.type == 'telegram') {
        this.upd_channel.params = this.upd_channel.chat_id
      }else if (this.upd_channel.type == 'email') {
        this.upd_channel.params = this.upd_channel.email
      }

      if (this.upd_channel.name === '' || this.upd_channel.name === undefined) {
        this.global_notify('danger', this.translate('notification.field.name'))
        return
      }

      if (this.upd_channel.type === '' || this.upd_channel.type === undefined) {
        this.global_notify('danger', this.translate('notification.field.type'))
        return
      }

      if (this.upd_channel.params == '' || this.upd_channel.params === undefined) {
        this.global_notify('danger', this.translate('notification.field.params'))
        return
      }

      delete this.upd_channel.email
      delete this.upd_channel.chat_id

      this.$emit('update', this.upd_channel)
      this.$emit('close', this.upd_channel)
    },
    deleteChannel () {
      this.$emit('delete', this.upd_channel)
      this.$emit('close', this.upd_channel)
    }
  },
}

</script>
<style lang='scss'>
  .content{
    button{
      margin: 0 5px;
    }
  }
  .form-item{
    .telegram{
      position: relative;
      .mdi-help{
        border-radius: 50%;
        border: 1px solid #9A9A9A;
        padding: 1px;
        margin-left: 2px;
        -webkit-transition: 0.2s;
        transition: 0.2s;
        cursor: pointer;
        font-size: 10px;
        &:hover{
          color: #41B883;
          border-color: #41B883;
        }
      }
      .hide_text{
        width: 300px;
        position: absolute;
        bottom: -43px;
        left: 85px;
        z-index: 2;
        white-space: normal;
        background: #f9f9f9;
        padding: 10px;
        border-radius: 5px;
        transition: 0.2s;
        box-shadow: 1px 1px 5px #202020;
        opacity: 0;
        transform: translateY(200px);
        &.active{
          opacity: 1;
          transform: translateY(0);
        }
      }
    }
  }
</style>
